// Canonical Stripe payment links (source: /Users/minihive/HIVE-AGENTS/CANONICAL-STRIPE-LINKS.md)
// Tier ladder: /Users/minihive/HIVE-KNOWLEDGE/00-command/CANONICAL-PRICING-2026-04-17.md
// If this file disagrees with the canonical docs, the canonical docs win.
//
// FAME surfaces T5 setup, T7 monthly, T8 FASS, T9 DFY, and the three T10 retainers.
// The lower tiers are included so components can reuse this across future pages.

export const STRIPE_LINKS = {
  // T1 $29 — AI Deployment Playbook
  T1_PLAYBOOK: 'https://buy.stripe.com/4gM14n8L72291oxcH6gfu0r',
  // T2 $197 — Core Stack Bundle
  T2_CORE_STACK: 'https://buy.stripe.com/bJedR9bXj7mt4AJfTigfu2h',
  // T3 $297 — Voice Agent Skill
  T3_VOICE_AGENT: 'https://buy.stripe.com/8x27sL6CZ8qxebjgXmgfu2i',
  // T4 $497 — Quick Fix (FDME lane, included for completeness)
  T4_QUICK_FIX: 'https://buy.stripe.com/9B6eVd1iFgX3gjrgXmgfu2f',
  // T4.5 $997 — AI Implementation Assessment
  T4_5_ASSESSMENT: 'https://buy.stripe.com/fZueVd0eBbCJ4AJ9uUgfu2g',
  // T5 $1,497 — AI Receptionist Setup
  T5_RECEPTIONIST_SETUP: 'https://buy.stripe.com/00wcN55yVgX37MVgXmgfu2j',
  // T6 $497/mo — Managed Growth
  T6_MANAGED_GROWTH: 'https://buy.stripe.com/9B69ATe5r6ip3wF9uUgfu2e',
  // T7 $297/mo — AI Receptionist Monthly
  T7_RECEPTIONIST_MONTHLY: 'https://buy.stripe.com/4gMfZhf9v9uB1ox4aAgfu2k',
  // T8 Standard $1,997/mo — FASS Standard
  T8_FASS_STANDARD: 'https://buy.stripe.com/14A4gz7H3cGNgjr8qQgfu2l',
  // T8 Pro $2,997/mo — FASS Pro
  T8_FASS_PRO: 'https://buy.stripe.com/dRm5kD5yV8qx6IRePegfu2m',
  // T9 $2,497 — DFY Install / Enterprise Security
  T9_DFY_ENTERPRISE: 'https://buy.stripe.com/eVq00jgdzcGN0kt6iIgfu2n',
  // T10 Starter $2,500/mo — FAME Agency Retainer (Starter)
  T10_STARTER: 'https://buy.stripe.com/28EaEX4uRdKR3wFcH6gfu2o',
  // T10 Growth $5,000/mo — FAME Agency Retainer (Growth)
  T10_GROWTH: 'https://buy.stripe.com/aFa14n4uR0Y5ffndLagfu2p',
  // T10 Dominance $10,000/mo — FAME Agency Retainer (Dominance)
  T10_DOMINANCE: 'https://buy.stripe.com/cNidR9e5r5el5EN22sgfu2q',
} as const;

export type StripeLinkKey = keyof typeof STRIPE_LINKS;
